module.exports = __webpack_public_path__ + "static/mobile-nav-logo-vascepa-5a2e6120babb86a7c79c10e5371fd05c.svg";